export default "__VITE_ASSET__DlPAB9O0__"